import { Schema } from "effect";
import {
  AccountId,
  ConversationId,
  ConversationThreadId,
  ShopperAiIntegrationId,
} from "../../../ids/definitions";
import { MessageChannel } from "./message";
import {
  ChatFlowThreadChannelData,
  EmailThreadChannelData,
  MetaCommentThreadChannelData,
  ThreadAnalyticsData,
} from "./thread/channel-data";

const threadBaseFields = {
  id: ConversationThreadId,
  conversationId: ConversationId,
  integrationId: ShopperAiIntegrationId,
  accountId: AccountId,
  externalThreadId: Schema.String,
  channel: MessageChannel,
  analyticsData: Schema.NullOr(ThreadAnalyticsData),
};

const EmailConversationThread = Schema.Struct({
  ...threadBaseFields,
  integrationType: Schema.Union(
    Schema.Literal("gmail"),
    Schema.Literal("outlook"),
  ),
  channelData: Schema.NullOr(EmailThreadChannelData),
});

const MetaCommentConversationThread = Schema.Struct({
  ...threadBaseFields,
  integrationType: Schema.Union(
    Schema.Literal("facebook"),
    Schema.Literal("instagram"),
  ),
  channelData: Schema.NullOr(MetaCommentThreadChannelData),
});

const ChatFlowConversationThread = Schema.Struct({
  ...threadBaseFields,
  integrationType: Schema.Literal("redoChatFlow"),
  channelData: Schema.NullOr(ChatFlowThreadChannelData),
});

const NullChannelConversationThread = Schema.Struct({
  ...threadBaseFields,
  integrationType: Schema.Union(
    Schema.Literal("tiktok"),
    Schema.Literal("attentive"),
    Schema.Literal("number"),
    Schema.Literal("postscript"),
    Schema.Literal("redoChatAi"),
    Schema.Literal("redoChatLive"),
  ),
  channelData: Schema.Null,
});

export const ConversationThread = Schema.Union(
  EmailConversationThread,
  MetaCommentConversationThread,
  ChatFlowConversationThread,
  NullChannelConversationThread,
);
export type ConversationThread = typeof ConversationThread.Type;

export const ConversationThreadCursor = Schema.Struct({
  id: ConversationThreadId,
});
export type ConversationThreadCursor = typeof ConversationThreadCursor.Type;
